'use client';

import dynamic from 'next/dynamic';

import { useState, useEffect } from 'react';

const AboutSection = dynamic(() => import('@/components/AboutSection'), { ssr: false });

interface AboutSectionClientProps {
  localePrefix?: string;
}

export default function AboutSectionClient({ localePrefix }: AboutSectionClientProps) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) return null;
  return <AboutSection localePrefix={localePrefix} />;
}
